import { createContext } from "react";
import type { WebsiteProductOfferingPlugin } from "./types";

export type OfferingsContextValue = {
  offerings: WebsiteProductOfferingPlugin[];
  isLoading: boolean;
};

export const OfferingsContext = createContext<OfferingsContextValue | undefined>(undefined);
